// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budget-requests {
  background-color: #F3F5F7;
  height: 100%;
}
.budget-requests .icon-add {
  font-size: 2.08rem;
  padding-right: 6px;
  position: relative;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
